// extracted by mini-css-extract-plugin
export var actionIcon = "_sw-0";